
import React from 'react'
import { Container } from 'semantic-ui-react'
import { translate, getLanguage } from 'react-switch-lang'
import { withRouter } from 'react-router'
import { compose } from 'recompose'
import MyPage from '../../core/components/MyPage'
import LayoutWithHeaderFooter from '../layout/LayoutWithHeaderFooter'
import ViewHeader from '../layout/ViewHeader'
import ViewFooter from '../layout/ViewFooter'
import FAQModel from '../../models/FAQModel'

class ViewFAQ extends MyPage {
    constructor(props) {
        super(props)
        this.state.isLoading = false
        this.state.model = new FAQModel()
    }

    componentDidMount() {
        this.onGetData()
    }

    onGetData = () => {
        this.setState({
            isLoading: true
        }, async () => {
            let tempState = {
                isLoading: false,
            },
                action = () => {

                }

            let res = await this.props.onGetFAQ()
            if (!!res && res.result === true && res.data instanceof FAQModel) {
                tempState.model = res.data
            }
            this.setState(tempState, action)
        })
    }
    render() {
        const { t } = this.props
        const { model } = this.state
        let content = model.getContentByLanguage(getLanguage())
        return (
            <React.Fragment>
                {super.render()}
                <LayoutWithHeaderFooter
                    header={<ViewHeader />}
                    footer={<ViewFooter />}
                >
                    <div className="module viewFAQ">
                        <Container text>
                            <div className="faq-wrapper">
                                <div className="faq-header">
                                    <h1>{t("common.faq")}</h1>
                                </div>
                                <div>
                                    <div dangerouslySetInnerHTML={{ __html: content }} />
                                </div>
                            </div>
                        </Container>
                    </div>
                </LayoutWithHeaderFooter>
            </React.Fragment>
        )
    }
}


ViewFAQ.defaultProps = {
    onGetFAQ: () => {
        console.error("Please provide Get FAQ action.")
        return null
    },
}

const enhance = compose(
    translate,
    withRouter,
)


export default enhance(ViewFAQ)